var _defs, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvweth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_30938",
    width: 256,
    height: 256.001,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.843,
    x2: 0.206,
    y1: 0.135,
    y2: 0.886,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6509e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ebac6"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-3{fill:#3b3735}.cls-5{fill:#959190}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1585",
    cx: 128,
    cy: 128,
    r: 128,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17812",
    transform: "translate(-20 -20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_108",
    fill: "url(#linear-gradient)",
    d: "M128 256a128.976 128.976 0 0 1-25.8-2.6 127.309 127.309 0 0 1-45.77-19.261 128.366 128.366 0 0 1-46.375-56.315A127.357 127.357 0 0 1 2.6 153.8a129.251 129.251 0 0 1 0-51.593 127.31 127.31 0 0 1 19.26-45.77 128.372 128.372 0 0 1 56.317-46.378A127.33 127.33 0 0 1 102.2 2.6a129.244 129.244 0 0 1 51.593 0 127.308 127.308 0 0 1 45.77 19.26 128.367 128.367 0 0 1 46.375 56.316A127.343 127.343 0 0 1 253.4 102.2a129.248 129.248 0 0 1 0 51.593 127.3 127.3 0 0 1-19.26 45.77 128.382 128.382 0 0 1-56.316 46.375A127.4 127.4 0 0 1 153.8 253.4 128.977 128.977 0 0 1 128 256zm0-242.287a115.145 115.145 0 0 0-23.033 2.322A113.657 113.657 0 0 0 64.1 33.232a114.622 114.622 0 0 0-41.4 50.283 113.7 113.7 0 0 0-6.659 21.452 115.4 115.4 0 0 0 0 46.065 113.66 113.66 0 0 0 17.2 40.866 114.627 114.627 0 0 0 50.282 41.407 113.75 113.75 0 0 0 21.453 6.658 115.381 115.381 0 0 0 46.065 0 113.609 113.609 0 0 0 40.866-17.2 114.622 114.622 0 0 0 41.393-50.278 113.741 113.741 0 0 0 6.659-21.453 115.4 115.4 0 0 0 0-46.065 113.662 113.662 0 0 0-17.2-40.865A114.619 114.619 0 0 0 172.485 22.7a113.74 113.74 0 0 0-21.453-6.659A115.145 115.145 0 0 0 128 13.714z",
    transform: "translate(20 20)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ETH",
    transform: "translate(85.371 49.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2995",
    d: "M155.4 72.338v48.6L215.463 36.3z",
    className: "cls-3",
    transform: "translate(-89.872 75.636)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2996",
    d: "M213.279 111.9 155.4 15.8v69.892z",
    className: "cls-3",
    transform: "translate(-89.872 -15.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2997",
    fill: "#1f1d19",
    d: "M155.4 29.6v59.517l57.333-33.308z",
    transform: "translate(-89.872 45.735)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2998",
    d: "m143.8 111.9 57.879-96.1v69.892z",
    className: "cls-5",
    transform: "translate(-141.615 -15.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2999",
    fill: "#403c3a",
    d: "M201.233 29.6v59.517L143.9 55.809z",
    transform: "translate(-141.174 45.735)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3000",
    d: "M203.463 72.338v48.6L143.4 36.3z",
    className: "cls-5",
    transform: "translate(-143.4 75.636)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvweth);
export default __webpack_public_path__ + "static/media/avweth.c355d17c124d8a7f5e0f77a66b090958.svg";
export { ForwardRef as ReactComponent };